<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('langNew2.flzq')}}</div>
        </div>
        <div class="cont-box">
            <div class="cont" v-html="content"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'benefitsDetail',
    data () {
        return {
          id: '',
          content: ''
        }
    },
    mounted(){
      this.id = this.$route.query.id;
      this.getFuli();
    },
    methods: {
      getFuli(){
		  	let params = {
            token: 1,
            id: this.id
        }
        this.$ajax.get('/web/getFuli',{params}).then((res) => {
          let resData = res.data.data[0];
          this.content = this.contHtml(resData.content);
        }).catch(function(err){
            console.log(err)
        })
      },
      contHtml(str){
          str = str.replace(/&amp;/g, '&');
          str = str.replace(/&lt;/g, '<');
          str = str.replace(/&gt;/g, '>');
          str = str.replace(/&quot;/g, "''");
          str = str.replace(/&#039;/g, "'");
          return str;
      },
      goBack(){
          this.$router.go(-1);
      }
    },
    filters: {
        times: function(timestamp){
            var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var h = date.getHours() + ':';
            var m = date.getMinutes() + ':';
            var s = date.getSeconds();
            return Y + M + D;
        }
    },
}
</script>
<style scoped>
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .center{
        text-align: center;
    }
    .head{
        position: relative;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .32rem;
        height: .6rem;
    }

    .cont-box{
        position: absolute;
        left: 0;
        top: 1.2rem;
        bottom: 0;
        width: 100%;
        height: auto;
        padding: 0 .3rem;
        box-sizing: border-box;
        overflow-y: auto;
    }
    .cont{
        padding: .4rem 0;
        color: #acacac!important;
        font-size: .48rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/benefitsDetail.vue